import Core from "@/modules/core/service/Core";

const url = {
    counts      : "/api/inbox/imports/counts",
};

export default {
    height (expanded, length) {
        if (expanded) {
            return 68  + length * 44;
        } else {
            return 82 + 28;
        }
    },

    isEmail (item) {
        return item.messages || item.contentType === "application/vnd.ms-outlook" || item.contentType === "HTML" || item.contentType === "TEXT";
    },

    isIncident (message) {
        return message.type.id === "INCIDENT";
    },

    counts (success) {
        Core.method.get(url.counts).then((data) => {
            success(data);
        });
    }
}
